export enum ModuleEnum {
    CUSTOMER = 'customers',
    HOARDING = 'hoardings',
    HOARDING_GROUP = 'hoardingGroups',
    PLAN = 'plans',
    CAMPAIGN = 'campaigns',
    CAMPAIGN_ITEM  = 'campaignItems',
    // BILLING = 'billings',
    GROUPS = 'groups',
    POINT_OF_CONTACT  = 'pointOfContacts',
    CONTRACT = 'contracts',
    // USER = 'sib_users'
}
